//this is a polyfill of some sort, for memfs

const processMock = {
  emitWarning: () => {},
  env: {
    NODE_PATH: process.env.NODE_ENV | 'development'
  },
  browser: true,
  platform: 'browser',
  getuid: () => 100,
  getgid: () => 100
};  

module.exports = processMock;
module.exports.default = processMock;
